import { BsHouseDoor } from "../../../assets/icons/vander";
import { PatientInfoCard, PatientSurgeryInfocard } from "../cards";
import { VirtualAssistantChat } from "../chat";

export const FlowContainer = () => {
  // Datos del hook ----------------------------------------//
  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//

  return (
    <>
      <div className="bg-light" style={{ minHeight: "100vh" }}>
        <div className="container-xl py-4">
          <nav aria-label="breadcrumb" className="d-inline-block mb-4">
            <ul className="breadcrumb rounded mb-0 p-0">
              <li className="breadcrumb-item" aria-current="page">
                <BsHouseDoor className="icons-sm" /> Paciente
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Perfil
              </li>
            </ul>
          </nav>
          <div className="vstack gap-4">
            <h1 className="mb-0">Información del paciente</h1>
            <PatientInfoCard />
            <PatientSurgeryInfocard />
          </div>
        </div>
      </div>

      <VirtualAssistantChat />
    </>
  );
};
